import { useBackend } from "../../services";

export const useGetShelving = () => {
  const { get } = useBackend();
  const getShelving = (uuid: string) => get(`shelvings/${uuid}`);
  return { getShelving };
};
